const CDN_ENV = process.env.REACT_APP_CDN_ENV || "";

const DIGITALOCEAN_BASE_URL = `https://pluslifepublic.tor1.cdn.digitaloceanspaces.com/${CDN_ENV}`;

export const getClinicId = (user) => {
    const envClinicId = process.env.REACT_APP_CLINIC_ID; 
    return envClinicId && envClinicId !== "0" ? Number(envClinicId) : user?.clinic_id;
  };
  

export const getClinicLogoUrl = () => {
    const envClinicId = process.env.REACT_APP_CLINIC_ID;

    // If envClinicId exists and is not "0", return the CDN logo URL
    return envClinicId && envClinicId !== "0"
        ? `${DIGITALOCEAN_BASE_URL}/clinic/c${envClinicId}/images/logo${envClinicId}.svg`
        : "/images/logos/PlusLife-Logo-2.png";
};

export const getClinicName = () => {
    return process.env.REACT_APP_CLINIC_NAME || null;
};

export const getClinicTagLine = () => {
    return process.env.REACT_APP_CLINIC_TAGLINE || null;
};

export const getClinicBannerUrl = (user) => {
    const envClinicId = process.env.REACT_APP_CLINIC_ID;

    return envClinicId && envClinicId !== "0"
        ? `${DIGITALOCEAN_BASE_URL}/clinic/c${envClinicId}/images/banner${envClinicId}.jpg`
        : null;
};

export const isWhiteLabelEnabled = () => {
    const envClinicId = process.env.REACT_APP_CLINIC_ID;
    return envClinicId && envClinicId !== "0"; 
};

export const getStripePublicKey = () => {
    return process.env.REACT_APP_STRIPE_PUBLIC_KEY || "";
};
